import { useState, useEffect } from "react";
import Icon, { IconName } from "../assets/icons";

interface SelectProps {
  label?: string;
  name: string;
  options: { value: string; label: string; icon?: IconName }[];
  className?: string;
  onChange?: (selectedValue: string) => void;
  value?: string;
  error?: string;
  viewerType?: string;
  icon?: IconName;
  placeholder?: string;
}

export default function FIlterSelect({
  label,
  options,
  className,
  name,
  onChange,
  value,
  error,
  viewerType,
  icon,
  placeholder = "Filter",
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    options.find((option) => option.value === value) || null
  );

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: {
    value: string;
    label: string;
    icon?: IconName;
  }) => {
    setSelectedOption(option);
    onChange?.(option.value);
    setIsOpen(false);
  };

  useEffect(() => {
    const newSelected = options.find((option) => option.value === value);
    setSelectedOption(newSelected || null);
  }, [value, options]);

  return (
    <div className={`relative inline-block ${className}`}>
      <label>{label}</label>
      <div
        onClick={toggleDropdown}
        className="flex justify-between items-center h-[40px] gap-2 px-4 py-2 mt-2 bg-transparent border border-[#9D9898] rounded-full cursor-pointer shadow-sm hover:shadow-md"
      >
        <section className="flex gap-2 items-center">
          {/* <Icon name={icon} className="w-4 h-4" /> */}
          <span className="text-sm text-[#1D2939] capitalize font-medium">
            {selectedOption ? `${selectedOption.label}` : placeholder}
          </span>
        </section>
        <Icon name="dropdownIcon" className="w-4 h-4" />
      </div>

      {isOpen && (
        <ul className="absolute left-0 mt-2 w-full bg-white border border-[#E5E7EB] rounded-md shadow-md max-h-60 overflow-y-auto z-10">
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => handleOptionClick(option)}
              className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              {option.icon && <Icon name={option.icon} className="w-4 h-4" />}
              <span className="text-sm text-[#1D2939]">{option.label}</span>
            </li>
          ))}
        </ul>
      )}
      {error && <span className="text-xs text-red-600 mt-1">{error}</span>}
    </div>
  );
}
